import { useEffect, useState } from "react";
import delayCallback from "../utils/delayCallback";

interface UseDelayOnMountProps {
  delay?: number;
}

/**
 * Hook to simulate a delay on mount
 */
const useDelayOnMount = (props: UseDelayOnMountProps = {}) => {
  const { delay = 0 } = props;

  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    const handleSetIsComplete = () => setIsComplete(true);

    const { clear } = delayCallback(handleSetIsComplete, delay);

    return () => {
      clear();
    };
  }, [delay]);

  return {
    isComplete,
  };
};

export default useDelayOnMount;
